import React from 'react';
import { ArrowLeft, Truck, Globe, Package, Clock, Shield, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

export const ShippingDelivery = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F7] pt-32 pb-16">
      <div className="container mx-auto px-4">
        <Button
          variant="ghost"
          className="mb-6 text-[#2C2C2C] hover:text-[#C4B5A0]"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="bg-[#F5F3F0] p-6 rounded-full">
                <Truck className="h-12 w-12 text-[#C4B5A0]" />
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-seasons font-light text-[#2C2C2C] mb-4">
              Shipping & Delivery
            </h1>
            <p className="text-[#8B7D6B] font-montserrat">
              We deliver across India and internationally with reliable courier partners
            </p>
          </div>

          {/* Pan India Shipping */}
          <Card className="bg-white border-none shadow-lg p-8 mb-8">
            <div className="flex items-start gap-4 mb-6">
              <div className="bg-[#F5F3F0] p-3 rounded-full">
                <Package className="h-6 w-6 text-[#C4B5A0]" />
              </div>
              <div>
                <h2 className="text-2xl font-seasons text-[#2C2C2C] mb-2">Pan India Shipping</h2>
                <p className="text-[#8B7D6B] font-montserrat">We deliver to all states and union territories across India</p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 text-[#2C2C2C] font-montserrat">
              <div className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Standard Delivery</h3>
                  <p className="text-sm text-[#8B7D6B]">5-7 business days for most locations</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Free Shipping</h3>
                  <p className="text-sm text-[#8B7D6B]">On orders above ₹2,999</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">COD Available</h3>
                  <p className="text-sm text-[#8B7D6B]">Cash on Delivery option for eligible orders</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <CheckCircle className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Order Tracking</h3>
                  <p className="text-sm text-[#8B7D6B]">Real-time tracking with courier partners</p>
                </div>
              </div>
            </div>
          </Card>

          {/* International Shipping */}
          <Card className="bg-white border-none shadow-lg p-8 mb-8">
            <div className="flex items-start gap-4 mb-6">
              <div className="bg-[#F5F3F0] p-3 rounded-full">
                <Globe className="h-6 w-6 text-[#C4B5A0]" />
              </div>
              <div>
                <h2 className="text-2xl font-seasons text-[#2C2C2C] mb-2">International Shipping</h2>
                <p className="text-[#8B7D6B] font-montserrat">We ship worldwide to bring Indian ethnic wear to customers globally</p>
              </div>
            </div>

            <div className="space-y-4 text-[#2C2C2C] font-montserrat">
              <div className="flex items-start gap-3">
                <Clock className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Delivery Time</h3>
                  <p className="text-sm text-[#8B7D6B]">10-15 business days (varies by destination)</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Shield className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Customs & Duties</h3>
                  <p className="text-sm text-[#8B7D6B]">Customer responsible for applicable customs duties and import taxes</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Package className="h-5 w-5 text-[#C4B5A0] flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold mb-1">Secure Packaging</h3>
                  <p className="text-sm text-[#8B7D6B]">Premium packaging to ensure safe international transit</p>
                </div>
              </div>
            </div>

            <div className="mt-6 p-4 bg-[#F5F3F0] rounded-lg">
              <p className="text-sm text-[#2C2C2C] font-montserrat">
                <strong className="text-[#6B4E37]">Note:</strong> International shipping charges vary by destination and order weight. Please contact us at ssons1975@gmail.com for a shipping quote to your country.
              </p>
            </div>
          </Card>

          {/* Our Courier Partners */}
          <Card className="bg-white border-none shadow-lg p-8">
            <h2 className="text-2xl font-seasons text-[#2C2C2C] mb-6">Our Courier Partners</h2>
            <p className="text-[#8B7D6B] font-montserrat mb-6">
              We partner with India's most reliable and reputed courier services to ensure your orders reach you safely and on time:
            </p>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="bg-[#F5F3F0] p-4 rounded-lg text-center">
                <p className="font-montserrat text-[#2C2C2C] font-semibold">Blue Dart</p>
              </div>
              <div className="bg-[#F5F3F0] p-4 rounded-lg text-center">
                <p className="font-montserrat text-[#2C2C2C] font-semibold">FedEx</p>
              </div>
              <div className="bg-[#F5F3F0] p-4 rounded-lg text-center">
                <p className="font-montserrat text-[#2C2C2C] font-semibold">DHL Express</p>
              </div>
              <div className="bg-[#F5F3F0] p-4 rounded-lg text-center">
                <p className="font-montserrat text-[#2C2C2C] font-semibold">Delhivery</p>
              </div>
              <div className="bg-[#F5F3F0] p-4 rounded-lg text-center">
                <p className="font-montserrat text-[#2C2C2C] font-semibold">DTDC</p>
              </div>
              <div className="bg-[#F5F3F0] p-4 rounded-lg text-center">
                <p className="font-montserrat text-[#2C2C2C] font-semibold">India Post</p>
              </div>
            </div>
          </Card>

          <div className="mt-8 text-center">
            <p className="text-[#8B7D6B] font-montserrat mb-4">
              Have questions about shipping?
            </p>
            <Button
              className="bg-[#C4B5A0] hover:bg-[#B0A090] text-white font-montserrat tracking-wider uppercase"
              onClick={() => navigate('/contact')}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};